import { createTheme } from '@mui/material/styles';
import { Theme as MuiTheme } from '@mui/material';
declare module '@emotion/react' {
  export interface Theme extends MuiTheme {}
}

// Create a theme instance.
let theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 700,
      md: 992,
      lg: 1280,
      xl: 1400,
    },
  },
  palette: {
    primary: {
      main: '#2ADDBA',
    },
    background: {
      default: '#070A1E',
    },
    text: {
      primary: '#fff',
      secondary: 'rgba(255, 255, 255, 0.6)',
    },
  },
});

theme = {
  ...theme,
  typography: {
    ...theme.typography,
    h1: {
      fontSize: '48px',
      lineHeight: '56px',
      fontWeight: 700,
      fontFamily: 'Nippo',
      [theme.breakpoints.up('md')]: {
        fontSize: '72px',
        lineHeight: '80px',
        letterSpacing: '6px',
      },
    },
    h2: {
      fontSize: '48px',
      lineHeight: '56px',
      fontWeight: 500,
      fontFamily: 'Nippo',
      [theme.breakpoints.up('md')]: {
        fontSize: '48px',
        lineHeight: '80px',
        letterSpacing: '4px',
      },
    },
    h3: {
      fontSize: '34px',
      lineHeight: '38px',
      fontWeight: 500,
      fontFamily: 'Nippo',
    },
    h4: {
      fontSize: '26px',
      lineHeight: '34px',
      fontWeight: 500,
      fontFamily: 'Nippo',
    },
    body1: {
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '26px',
      fontFamily: 'General Sans',
    },
    body2: {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '22px',
      fontFamily: 'General Sans',
    },
  },
};

export default theme;
